import React, { useEffect, useState } from 'react'
import { Form, Dropdown, Label } from 'semantic-ui-react';
import GlobalContext from './../../../contexts/GlobalContext';
import Utility from './../../../Utility'
import './InputSelectDate.css';
import Moment from 'moment';
import 'moment-timezone';

/**
 * Components InputSelectDate
 * Retourne jsx de 3 select (jour, mois, ann�es)
 * @param {string} props.name
 * @param {string} props.value
 * @param {bool} props.search
 * @param {bool} props.labelError
 * @param {bool} props.error
 * @param {bool} props.required
 * @param {bool} props.disabled
 */
const InputSelectDate = (props) => {
  const [globalContext] = useState(GlobalContext);
  const [dateNaissanceState, setDateNaissanceState] = useState({});
  const [listOptionsState, setListOptionsState] = useState({});
  const [errorState, setErrorState] = useState(false);

  useEffect(() => {
    let listOptions = {
      days: getListOptionsDays(),
      months: getListOptionsMonths(),
      years: getListOptionsYears()
    }
    setListOptionsState(listOptions);
  }, []);

  useEffect(() => {
    setDateNaissanceState(props.value);
    if (props.error !== undefined) {
      setErrorState(props.error);
    }
  }, [props]);

  /**
   * Retourne la liste des options du select de la journ�e
   */
  const getListOptionsDays = () => {
    let listOptions = [];
    for (let i = 1; i <= 31; i++) {
      let text = i.toString();
      if (i < 10) {
        text = '0' + text;
      }
      listOptions.push({
        key: i,
        text: text,
        value: i,
      });
    }

    return listOptions;
  }

  /**
   * Retourne la liste des options du select du mois
   */
  const getListOptionsMonths = () => {
    let date = new Moment();
    let listOptions = [];
    //On passe au jour un du mois pour evite les erreurs
    date.date(1);

    for (let i = 0; i <= 11; i++) {
      date.month(i);
      listOptions.push({
        key: i,
        text: date.format('MMMM'),
        value: i,
      });
    }

    return listOptions;
  }

  /**
   * Retourne la liste des options du select des ann�es
   */
  const getListOptionsYears = () => {
    let dateNow = new Moment();
    let listOptions = [];
    for (let i = parseInt(dateNow.format('YYYY')); i >= 1900; i--) {
      listOptions.push({
        key: i,
        text: i,
        value: i,
      });
    }

    return listOptions;
  }

  /**
   * Event lorsque la valeur de l'input change
   */
  const handleChange = (event, { value }) => {
    let dateNaissanceTemp = new Moment(dateNaissanceState);
    if (dateNaissanceTemp.isValid() === false) {
      dateNaissanceTemp = new Moment();
    }
    value = parseInt(value);
    switch (event.target.closest('.dropdown').id) {
      case props.name + 'Month':
        dateNaissanceTemp.month(value);
        break;
      case props.name + 'Year':
        dateNaissanceTemp.year(value);
        break;
      default:
        dateNaissanceTemp.date(value);
        break;
    }

    let test = Utility.checkValue(props.name, dateNaissanceTemp.format('YYYY-MM-DD'), props.typePattern);
    setErrorState(test.error);

    if (props.handleChange) {
      props.handleChange(props.name, dateNaissanceTemp.format('YYYY-MM-DD'))
    }
    setDateNaissanceState(dateNaissanceTemp.format('YYYY-MM-DD'));
  }

  /**
   * Retourne l'object Jsx du dropdown en fonction des datas
   * @param {Objact} data 
   * @returns Object jsx
   */
  const dropdown = (data) => {
    let { label, id, value, listOptions, search, key, disabled } = data;
    if (listOptions === undefined) {
      return null;
    } else {
      return (
        <Dropdown
          selection
          placeholder={label}
          options={listOptions}
          // defaultValue={value}
          value={value}
          onChange={handleChange}
          search={search}
          compact
          id={id}
          key={key}
          disabled={props.disabled}
        >
        </Dropdown>
      )
    }
  }

  /**
   * Retourne l'object Jsx du dropdown des jours
   * @returns Object jsx
   */
  const dropdownDay = () => {
    let dateNaissance = new Moment(dateNaissanceState, 'YYYY-MM-DD');
    return dropdown({
      label: (globalContext && globalContext.translations && globalContext.translations.days) ? globalContext.translations.days : null,
      id: props.name + 'Day',
      value: parseInt(dateNaissance.format('D')),
      listOptions: listOptionsState.days,
      search: props.search,
      key: 'dropdownDay',
      disabled: props.disabled
    });
  }

  /**
   * Retourne l'object Jsx du dropdown des mois
   * @returns Object jsx
   */
  const dropdownMonth = () => {
    let dateNaissance = new Moment(dateNaissanceState, 'YYYY-MM-DD');
    return dropdown({
      label: (globalContext && globalContext.translations && globalContext.translations.month) ? globalContext.translations.month : null,
      id: props.name + 'Month',
      value: parseInt(dateNaissance.format('M')) - 1,
      listOptions: listOptionsState.months,
      search: props.search,
      key: 'dropdownMonth',
      disabled: props.disabled
    });
  }

  /**
   * Retourne l'object Jsx du dropdown des années
   * @returns Object jsx
   */
  const dropdownYear = () => {
    let dateNaissance = new Moment(dateNaissanceState, 'YYYY-MM-DD');
    return dropdown({
      label: (globalContext && globalContext.translations && globalContext.translations.years) ? globalContext.translations.years : null,
      id: props.name + 'Year',
      value: parseInt(dateNaissance.format('YYYY')),
      listOptions: listOptionsState.years,
      search: props.search,
      key: 'dropdownYear',
      disabled: props.disabled
    });
  }

  /**
   * Retourne jsx des differents select
   */
  const getInput = () => {
    let dateNaissance = new Moment(dateNaissanceState, 'YYYY-MM-DD');
    let dateMysql = '';
    if(dateNaissance.isValid()) {
      dateMysql = dateNaissance.format('YYYY-MM-DD')
    }
    return [
      <input key={'hidden'} type="hidden" name={'input_' + props.name} value={dateMysql} />,
      dropdownDay(),
      dropdownMonth(),
      dropdownYear(),
    ];
  }

  /**
   * Rendu du label en cas d'erreur
   * @returns Object jsx
   */
  const getLabelError = () => {
    if (errorState && props.labelError) {
      return (
        <Label basic color="red" pointing>
          {(props.labelError === true) ? globalContext.translations.enterValue : props.labelError}
        </Label>
      );
    } else {
      return null
    }
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <Form.Field required={props.required} error={errorState}>
      <label>{props.label}</label>
      <div className="divListDropdownDateNaissance">
        {getInput()}
      </div>
      {getLabelError()}
    </Form.Field>
  )
}

export default InputSelectDate;
